import { makeStyles } from '@material-ui/core';
import { LogoIcon } from './LogoIcon';

const useStyles = makeStyles({
  root: {
    alignItems: 'center',
    color: '#7df3e1',
    display: 'inline-flex',
    height: 30,
    whiteSpace: 'nowrap',
  },
  wordmark: {
    fontSize: 18,
    fontWeight: 500,
    letterSpacing: '0.01em',
    lineHeight: 1,
    marginLeft: 8,
  },
});

export const LogoFull = () => {
  const classes = useStyles();

  return (
    <span className={classes.root}>
      <LogoIcon />
      <span className={classes.wordmark}>Horizon Relevance</span>
    </span>
  );
};
